// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@5.2.7/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".nfts[data-v-ac9f0d1e]{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:1rem}.light-mode .nfts>*[data-v-ac9f0d1e]{border:1px solid #999}.light-mode .nfts[data-v-ac9f0d1e]>:hover{border-color:#000;opacity:.85}.dark-mode .nfts>*[data-v-ac9f0d1e]{border:1px solid #ccc}.dark-mode .nfts[data-v-ac9f0d1e]>:hover{border-color:#fff;opacity:.85}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
